import { getUserToken } from '../../services/localStorage';
import { BASE_API_URL } from '../../constants/constants';

export const getScreenerStatus = async (screenerId, userId) => {
    const token = getUserToken();
    const headers = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
        },
    };

    try {
        const response = await fetch(
            `${BASE_API_URL}/event_based_screener_statuses/${screenerId}?user_id=${userId}`,
            headers
        );

        if (!response.ok) {
            return { status: 'pending', screenerId };
        }

        const jsonResponse = await response.json();
        return jsonResponse;

    } catch (error) {
        throw new Error(error.toString());
    }
};

export const dismissScreener = async (screenerId, userId) => {
    const token = getUserToken();
    const headers = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
        },
    };

    try {
        const response = await fetch(
            `${BASE_API_URL}/event_based_screener_statuses/${screenerId}/dismiss?user_id=${userId}`,
            headers
        );

        if (!response.ok) {
            return { status: 'pending', screenerId };
        }

        const jsonResponse = await response.json();
        return jsonResponse;

    } catch (error) {
        throw new Error(error.toString());
    }
};

export const getScreener = async (screenerId) => {
    const token = getUserToken();
    const headers = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
        },
    };

    try {
        const response = await fetch(
            `${BASE_API_URL}/screeners/${screenerId}`,
            headers
        );

        if (!response.ok) {
            return { status: 'pending', screenerId };
        }

        const jsonResponse = await response.json();
        return jsonResponse;

    } catch (error) {
        throw new Error(error.toString());
    }
};

export const getKnowledgeCheck = async (id) => {
    const token = getUserToken();
    const headers = {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
        },
    };

    try {
        const response = await fetch(
            `${BASE_API_URL}/knowledge_checks/${id}`,
            headers
        );

        if (!response.ok) {
            return { status: 'pending', id };
        }

        const jsonResponse = await response.json();
        return jsonResponse;

    } catch (error) {
        throw new Error(error.toString());
    }
};